module.exports = __webpack_public_path__ + "static/media/travel17.1ac8fe31.jpg";